import { render, staticRenderFns } from "./SkillReadingLevel.vue?vue&type=template&id=4ed866f5&"
import script from "./SkillReadingLevel.vue?vue&type=script&lang=js&"
export * from "./SkillReadingLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports